export const IDENTITY_REGEX = /^([0-9]+(-[0-9]+)?(,(?=[0-9]))?)*$/;

/** Validates an identity string like "1,3,5-10" */
export function validateIdentityString(value: string): boolean {
  return IDENTITY_REGEX.test(value);
}

/** Compresses a sorted array of IDs into range notation: [1,2,3,5,6,8] → "1-3,5-6,8" */
export function clampAndWrapIdentity(ids: number[]): string {
  if (ids.length === 0) return "";
  const sorted = [...ids].sort((a, b) => a - b);
  const parts: string[] = [];
  let rangeStart = sorted[0]!;
  let rangeEnd = sorted[0]!;

  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] === rangeEnd + 1) {
      rangeEnd = sorted[i]!;
    } else {
      parts.push(rangeStart === rangeEnd ? String(rangeStart) : `${rangeStart}-${rangeEnd}`);
      rangeStart = sorted[i]!;
      rangeEnd = sorted[i]!;
    }
  }
  parts.push(rangeStart === rangeEnd ? String(rangeStart) : `${rangeStart}-${rangeEnd}`);
  return parts.join(",");
}

/** Expands a range string like "1-3,5,7-9" into a flat array [1,2,3,5,7,8,9] */
export function expandIdentityString(value: string): number[] {
  if (!value.trim()) return [];
  const result: number[] = [];
  for (const part of value.split(",")) {
    const trimmed = part.trim();
    if (!trimmed) continue;
    const dash = trimmed.indexOf("-");
    if (dash > 0) {
      const start = parseInt(trimmed.substring(0, dash), 10);
      const end = parseInt(trimmed.substring(dash + 1), 10);
      if (!isNaN(start) && !isNaN(end)) {
        for (let i = start; i <= end; i++) result.push(i);
      }
    } else {
      const num = parseInt(trimmed, 10);
      if (!isNaN(num)) result.push(num);
    }
  }
  return result;
}
